import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IArticulo } from '@models/IArticulo';
import { IOperador, IGestor } from '@models/IOperador';
import { IUltimoStock } from '@models/IUltimoStock';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { INotification } from '@models/INotification';
import { IArticuloInventario } from '@features/notificar-inventario/pages/notificar-inventario/notificar-inventario.component';
import { KeysEstaticas } from '@shared/constantes/KeysStaticas';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class OperadorService {
  readonly SESSION_IDIOMA = KeysEstaticas.SESSION_IDIOMA;
  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) { }

  //9.1. GET: Funcion que devuelve los datos de un operador
  getOperador(): Observable<IOperador> {
    return this.http.get<IOperador>(
      environment.API_URL + 'cliente/operador'
    );
  }

  //9.3. PUT: Funcion que edita un operador (en datos operador)
  // TODO => contactoReclamaciones ESTO ES UNDEFINED MIRAR A VER Y PASAR BIEN EL DATO
  putEditOperador(contactoReclamaciones: string, emailFacturacion: string) {


    const body = { contactoReclamaciones, emailFacturacion };

    return this.http.put<IOperador>(
      `${environment.API_URL}cliente/operador`,
      body
    );
  }


  //9.4. GET: Funcion que devuelve los articulos autorizados para un operador
  getArticulosAll(): Observable<IArticulo[]> {
    const idioma = sessionStorage.getItem(this.SESSION_IDIOMA) || this.sessionService.getIdioma();


    return this.http.get<IArticulo[]>(
      environment.API_URL + 'cliente/operador/articulos/all'
    );
  }

  //9.11. GET: Funcion que devuelve los articulos autorizados x centro para un operador
  getArticulosCentroAll(centro: number): Observable<IArticulo[]> {
    const idioma = sessionStorage.getItem(this.SESSION_IDIOMA) || this.sessionService.getIdioma();

    return this.http.get<IArticulo[]>(
      environment.API_URL + 'cliente/operador/centro/articulos/all',
      {
        params: {
          idioma: idioma,
          centro: String(centro),
        },
      },
    );
  }

  //9.6. GET: Funcion que devuelve los datos del ultimo Stock
  getUltimoStockAll(): Observable<IUltimoStock> {

    return this.http.get<IUltimoStock>(
      environment.API_URL + 'cliente/operador/stock/ultimo/all'
    );
  }

  //9.7. POST: Funcion que crea un inventario
  postInventarioAdd(inventario: { fecha: Date; observaciones: string; inventario: IArticuloInventario[] }) {

    return this.http.post<unknown>(
      environment.API_URL + 'cliente/operador/inventario/all',
      inventario
    );
  }

  //9.8. GET: Funcion que devuelve el listado de los inventarios
  // getInventario()
  // {

  // }

  //9.9. POST: Funcion que crea un pedido extra
  postPedidoExtraAdd(artiuculos: { fecha: string; centro: number; observaciones: string; pedido: IArticulo[] }) {
    return this.http.post<unknown>(
      environment.API_URL + 'cliente/operador/pedidoextra',
      artiuculos
    );
  }

  getNotificaciones(): Observable<INotification[]> {
    const idioma = sessionStorage.getItem(this.SESSION_IDIOMA) || this.sessionService.getIdioma();

    return this.http.get<INotification[]>(
      `${environment.API_URL}cliente/operador/notificaciones/all`,
      {
        withCredentials: true,
        params: {
          idioma: idioma!,
        },
      }
    );
  }


  getFechasPedidoExtra() {

    return this.http.get<{
      valido: boolean;
      diaInicio: string;
      diaFin: string;
    }>(environment.API_URL + 'cliente/Operador/pedidoextra/fecha/validar');
  }


  getGestorPorOperador() {
    return this.http.get<IGestor>(environment.API_URL + 'cliente/Operador/gestor');
  }
}
